export enum AssignGiftCardTitleState {
  assign = 'assign',
  code = 'code',
  scan = 'scan',
}
